(function () {
  if (window.shippingProgressBarInitialized) return;

  window.shippingProgressBarInitialized = true;

  const selector = '.shipping_progress_fill[data-shipping-progress-target]';

  // Shopify replaces cart drawer/page HTML after cart mutations. Because the
  // DOM node is new each time, CSS alone has no memory of the previous width.
  // Keep the last target per cart surface so a section refresh can animate from
  // old percentage -> new percentage instead of 0 -> new percentage.
  const progressValues = window.shippingProgressBarValues || {};
  window.shippingProgressBarValues = progressValues;

  // The same snippet can render in the cart drawer and on the cart page. Track
  // those independently so opening/updating one surface does not affect the
  // starting width of the other.
  function getProgressKey(fill) {
    if (fill.closest('#CartDrawer')) return 'cart-drawer';
    if (fill.closest('#main-cart-items')) return 'cart-page';

    return 'cart';
  }

  // Clamp bad/missing data attributes instead of letting malformed values write
  // invalid CSS widths.
  function getTargetValue(fill) {
    const value = Number(fill.dataset.shippingProgressTarget || 0);
    return Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
  }

  function isStaticProgress(fill) {
    return fill.dataset.shippingProgressStatic === 'true';
  }

  function getProgressFills(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return [];

    const elements = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) {
      elements.push(root);
    }

    elements.push(...root.querySelectorAll(selector));
    return elements;
  }

  // Store the Liquid-rendered target, not the current animated pixel width. If
  // Shopify removes markup mid-transition, the next render should still start
  // from the last known cart state.
  function storeCurrentProgress(root, progressKey) {
    getProgressFills(root).forEach((fill) => {
      progressValues[progressKey || getProgressKey(fill)] = getTargetValue(fill);
    });
  }

  function animateProgress(root) {
    getProgressFills(root).forEach((fill) => {
      const target = getTargetValue(fill);
      const progressKey = getProgressKey(fill);
      const start = progressValues[progressKey] ?? 0;

      if (fill.dataset.shippingProgressAnimated === String(target)) return;

      fill.dataset.shippingProgressAnimated = String(target);

      // Free shipping is the terminal state. Show it as a static full bar so
      // the UI reads as complete instead of implying there is another tier.
      if (isStaticProgress(fill)) {
        fill.classList.remove('is-animating');
        fill.style.width = `${target}%`;
        progressValues[progressKey] = target;
        return;
      }

      // Set the starting width with transitions disabled, force the browser to
      // apply that layout, then enable the transition for the move to target.
      // This avoids the confusing 0 -> old -> new visual during section swaps.
      fill.classList.remove('is-animating');
      fill.style.width = `${start}%`;
      fill.offsetWidth;

      requestAnimationFrame(() => {
        fill.classList.add('is-animating');
        fill.style.width = `${target}%`;
        progressValues[progressKey] = target;
      });
    });
  }

  function onReady() {
    animateProgress(document);

    // Cart updates are rendered by existing theme scripts via HTML replacement.
    // Watching added/removed nodes lets this small script work for add-to-cart,
    // quantity changes, drawer refreshes, and cart-page refreshes without
    // coupling to a specific Shopify event payload.
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const progressKey = mutation.target.closest?.('#CartDrawer')
          ? 'cart-drawer'
          : mutation.target.closest?.('#main-cart-items')
            ? 'cart-page'
            : undefined;

        mutation.removedNodes.forEach((node) => {
          storeCurrentProgress(node, progressKey);
        });

        mutation.addedNodes.forEach((node) => {
          animateProgress(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
